<template>
  <div>
    <div id="login">
      <div class="menu" id="left">
        <div class="cut">
          <h1>{{ $t('login.title.name') }}</h1>
          <p>{{ $t('login.title.description') }}</p>
        </div>
      </div>
      <div class="menu" id="right">
        <div class="form-container" :class="{ 'signup-form': !showLoginForm }">
          <!-- LOGIN -->
          <form v-if="showLoginForm" @submit.prevent>
            <h3>{{ $t('login.form.title') }}</h3>
            <p v-if="workspaceIdToJoin">
              Connectez-vous ou inscrivez-vous pour rejoindre l'espace auquel
              vous avez été invité.
            </p>
            <div>
              <label for="email">{{ $t('login.form.email.label') }}</label>
              <input
                v-model.trim="loginForm.email"
                type="text"
                :placeholder="$t('login.form.email.placeholder')"
                id="email"
              />
            </div>
            <div>
              <label for="password">{{
                $t('login.form.password.label')
              }}</label>
              <input
                v-model.trim="loginForm.password"
                type="password"
                :placeholder="$t('login.form.password.placeholder')"
                id="password"
              />
            </div>
            <p v-if="errorCode" class="error">{{ errorText }}</p>
            <div class="btn-container">
              <button @click="login()" class="button valid">
                {{ $t('login.form.btn.login') }}
              </button>
              <a @click="toggleForm()">
                <button class="button">
                  {{ $t('login.form.btn.createAccount') }}
                </button>
              </a>
              <a @click="togglePasswordReset()">
                <button class="button is-light">
                  {{ $t('login.form.btn.resetPassword') }}
                </button>
              </a>
            </div>
          </form>

          <!-- SIGN UP -->
          <form v-else @submit.prevent>
            <h3>{{ $t('login.createForm.title') }}</h3>
            <div>
              <label for="name">{{ $t('login.createForm.name.label') }}</label>
              <input
                v-model.trim="signupForm.name"
                type="text"
                :placeholder="$t('login.createForm.name.placeholder')"
                id="name"
              />
            </div>
            <div>
              <label for="email">{{ $t('login.form.email.label') }}</label>
              <input
                v-model.trim="signupForm.email"
                type="text"
                :placeholder="$t('login.form.email.placeholder')"
                id="email"
              />
            </div>
            <div>
              <label for="password">{{
                $t('login.form.password.label')
              }}</label>
              <input
                v-model.trim="signupForm.password"
                type="password"
                :placeholder="$t('login.form.password.placeholder')"
                id="password"
              />
            </div>
            <p v-if="errorCode" class="error">{{ errorText }}</p>
            <div class="btn-container">
              <button @click="signup()" class="button valid">
                {{ $t('login.form.btn.validCreateAccount') }}
              </button>
              <a @click="toggleForm()">
                <button class="button">
                  {{ $t('login.form.btn.backLogin') }}
                </button>
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as fb from '../../firebase';
import workspaceService from '../../services/workspace.service';
import PasswordReset from '../../components/Modal/PasswordReset.vue';
import userService from '../../services/user.service';

export default {
  data() {
    return {
      showLoginForm: true,
      loginForm: {
        email: '',
        password: '',
      },
      signupForm: {
        name: '',
        email: '',
        password: '',
      },
      errorCode: null,
    };
  },
  mounted() {},
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.$modal.show(
        PasswordReset,
        {
          defaultEmail: this.loginForm.email || null,
        },
        {}
      );
    },
    async login() {
      try {
        await fb.auth.signInWithEmailAndPassword(
          this.loginForm.email,
          this.loginForm.password
        );
        // fetch user profile in main.js (on auth state change)
      } catch (err) {
        this.errorCode = err.code;
      }
    },
    async signup() {
      if (_.get(this.signupForm, 'name', '').length < 5) {
        this.errorCode = 'name-too-short';
        return;
      }
      // Create account, then workspace, then add workspace to user, then connect
      try {
        const res = await fb.auth.createUserWithEmailAndPassword(
          this.signupForm.email,
          this.signupForm.password
        );
        const userId = fb.auth.currentUser.uid;
        const userName = this.signupForm.name;
        const userEmail = this.signupForm.email;
        // if joining existing workspace
        const workspaces = [];
        if (this.workspaceIdToJoin) {
          const workspaceRef = workspaceService.getRef(this.workspaceIdToJoin);
          workspaces.push(workspaceRef);
          // remove workspaceIdToJoin
          this.$store.dispatch('setWorkspaceIdToJoin', null);
        } else {
          // create default workspace
          const workspace = await fb.workspacesCollection.add({
            name: userName,
            createdOn: new Date(),
            creatorId: userId,
            admins: [userId],
            default: true,
          });
          workspaces.push(workspace);
        }
        // Add user data
        const data = {
          name: userName,
          email: userEmail,
          workspaces,
        };
        await userService.createAccount(userId, data);
        // Get created user data
        this.$store.dispatch('fetchUserProfile', res.user);
      } catch (err) {
        this.errorCode = err.code;
      }
    },
  },
  computed: {
    errorText() {
      return this.$t(`login.errors.${this.errorCode}`);
    },
  },
};
</script>

<style lang="scss" scoped src="./Login.scss"></style>
